import React, { useContext, useEffect, useRef, useState } from "react";
import { useAppTheme } from "../../../hooks/useAppTheme";
import { StyleSheet, useColorScheme, View } from "react-native";
import { Modal, Text, TextInput, TouchableOpacity } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { DataTableWithPagination } from "../../../components/custom/DataTable/DataTableWithPagination";
import Spinner from "../../../components/shared/Spinner";
import DeviceOrientationContext from "../../../components/context/DeviceOrientationContext";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrackerEnquiriesByKey,
  searchTrackerEnquiriesByKey,
} from "../../../redux/dispatcher/productTrackerDispatcher";
import { LabelBannerWithSearchBar } from "../../../components/custom/Banners/LabelBannerWithSearchBar";
import { resetEnquiries } from "../../../redux/reducers/productTrackerReducer";
import ItemTrackerEnquiryReply from "./ItemTrackerEnquiryReply";
import TrackerHistoryReplyModal from "./TrackerHistoryReplyModal";
import { ChinaTrackerDataTableWithPagination2 } from "../../../components/custom/DataTable/tracker/ChinaTrackerDataTableWithPagination2";

interface TrackerEnquiryModalProps {
  visible: boolean;
  onClose: any;
  order: string;
}

const TrackerHistoryModal: React.FC<TrackerEnquiryModalProps> = ({
  visible,
  onClose,
  order,
}: any) => {
  const { colors } = useAppTheme();
  const styles = createStyles(colors);
  const listRef = useRef<ScrollView>(null);

  const [isSearched, setIsSearched] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);

  const dispatch = useDispatch<any>();
  const { loadingEnquiries, enquiries } = useSelector(
    (state: any) => state.productTracker
  );

  useEffect(() => {
    dispatch(getTrackerEnquiriesByKey(order.Key));
  }, [order]);

  const headers = {
    createdAt: {
      name: "Inquiry Date",
      width: 0.4,
    },
    createdBy: {
      name: "User",
      width: 0.3,
    },
    subject: {
      name: "Subject",
      width: 0.2,
    },
    priority: {
      name: "Priority",
      width: 0.2,
    },
    message: {
      name: "Message",
      width: 0.5,
    },
    enquiryActions: {
      name: "",
      width: 0.2,
      textAlign: "right",
    },
  };

  const [isRefresh, setRefresh] = useState<boolean>(false);

  const [tableHeaders, setTableHeaders] = useState<any>(headers);

  const { isLargeDevice, isMediumDevice, isSmallDevice } = useContext(
    DeviceOrientationContext
  );
  const [, setContentOffSet] = useState<number>(0);

  const handleScroll = (event: any) => {
    setContentOffSet(Math.floor(event.nativeEvent?.contentOffset?.y) ?? 0);
  };

  useEffect(() => {
    let isMounted: boolean = true;

    setTableHeaders(headers);
    setRefresh(false);

    return () => {
      isMounted = false;
    };
  }, [isRefresh]);

  const [modalOpen, setModalOpen] = useState<boolean>();
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [selectedEnquiryType, setSelectedEnquiryType] = useState<any>(null);

  const onCloseEnquiry = () => {
    setModalOpen(false);
  };

  const handleSearch = (searchedText: string) => {
    setPage(0);
    if (searchedText) {
      dispatch(
        searchTrackerEnquiriesByKey({ key: order.Key, search: searchedText })
      );
    } else {
      dispatch(resetEnquiries());
    }
  };

  const navigateToOrder = (order: any, action: string) => {
    setModalOpen(true);
    setSelectedItem(order);
    setSelectedEnquiryType(action);
  };

  return (
    <>
      {modalOpen && selectedEnquiryType === "reply" && (
        <ItemTrackerEnquiryReply
          onClose={onCloseEnquiry}
          visible={modalOpen}
          order={selectedItem}
          rootOrder={order}
        />
      )}

      {modalOpen && selectedEnquiryType != "reply" && (
        <TrackerHistoryReplyModal
          onClose={onCloseEnquiry}
          visible={modalOpen}
          order={selectedItem}
        />
      )}
      <Modal visible={visible} transparent animationType="slide">
        <View style={styles.overlay}>
          <View
            style={
              isLargeDevice
                ? styles.modalContainer
                : styles.modalContainerSecond
            }
          >
            <Text style={styles.title}>History</Text>

            <ScrollView onScroll={handleScroll} ref={listRef}>
              <View>
                <View>
                  <View
                    style={[
                      styles.containerContent,
                      {
                        width: isLargeDevice
                          ? "100%"
                          : isMediumDevice
                            ? "100%"
                            : "100%",
                      },
                    ]}
                  >
                    {!loadingEnquiries ? (
                      <View>
                        <LabelBannerWithSearchBar
                          titleName={`Total Items: ${enquiries.length}`}
                          handleSearch={handleSearch}
                          setRefresh={setRefresh}
                          dataToExport={enquiries}
                          fileName="ItemTrackerHistoryScreen"
                          sheetName="TrackerHistoryScreen"
                        />
                        <ChinaTrackerDataTableWithPagination2
                          headers={tableHeaders}
                          rows={enquiries}
                          itemsPerPage={10}
                          isDataLoading={isSearched}
                          isDisplayTimeWithDate={true}
                          useModal={true}
                          isDetail={false}
                          isEdit={false}
                          isDelete={false}
                          // Required props
                          setModalVisible={() => { }}
                          handleRowClick={() => { }}
                          setSelected={() => { }}
                          handleDeleteRow={() => { }}
                          operationActions={navigateToOrder}
                          page={page}
                          setPage={setPage}
                        />
                      </View>
                    ) : (
                      <View>
                        <Spinner
                          size="small"
                          color="#74BBFF"
                          styles={{ flexDirection: "row", margin: "20%" }}
                        />
                      </View>
                    )}
                  </View>
                </View>
              </View>
            </ScrollView>
            <View style={styles.footer}>
              <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                <Text style={styles.closeButtonText}>Close</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
    </>
  );
};

function createStyles(colors: any) {
  return StyleSheet.create({
    overlay: {
      flex: 1,
      backgroundColor: "rgba(0,0,0,0.2)",
      justifyContent: "center",
      alignItems: "center",
    },
    modalContainer: {
      backgroundColor: colors.surface,
      padding: 25,
      width: "76%",
      borderRadius: 10,
    },
    title: {
      fontSize: 25,
      fontWeight: "bold",
      color: colors.text,
      marginBottom: 35,
    },
    detailsContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 15,
    },
    column: {
      flex: 1,
    },
    label: {
      fontWeight: "bold",
      color: colors.textSecondary,
      fontSize: 16,
      marginBottom: 3,
    },
    value: {
      fontSize: 16,
      color: colors.text,
      marginBottom: 10,
      paddingLeft: 4,
    },
    dropdownRow: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: 10,
    },
    dropdownContainer: {
      flex: 1,
      marginRight: 10,
    },
    inputLabel: {
      fontWeight: "bold",
      color: colors.text,
      marginBottom: 5,
      marginTop: 20,
    },
    picker: {
      borderWidth: 1.5,
      borderColor: colors.border,
      height: 40,
      backgroundColor: colors.surface,
      borderRadius: 10,
    },
    messageInput: {
      height: 100,
      borderWidth: 1.5,
      borderColor: colors.border,
      padding: 10,
      backgroundColor: colors.surface,
      color: colors.text,
      marginBottom: 15,
      borderRadius: 10,
    },
    footer: {
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    userName: {
      fontSize: 14,
    },
    submitButton: {
      backgroundColor: colors.primary,
      paddingHorizontal: 20,
      paddingVertical: 10,
      borderRadius: 5,
    },
    submitText: {
      color: "#fff",
      fontWeight: "bold",
    },
    closeButton: {
      padding: 10,
      borderWidth: 1,
      borderColor: colors.text,
      borderRadius: 5,
    },
    closeButtonText: {
      color: colors.text,
    },
    buttonPrimary: { padding: 10, backgroundColor: colors.primary, borderRadius: 5 },
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      flexGrow: 1,
    },
    containerContent: {
      flexDirection: "column",
      alignSelf: "flex-start",
      justifySelf: "flex-start",
    },
    fab: {
      bottom: -10,
      position: "absolute",
      zIndex: 1,
    },
    modalContainerSecond: {
      backgroundColor: colors.surface,
      elevation: 8,
      height: "100%",
      width: "100%",
      padding: 10,
    },
  });
}

export default TrackerHistoryModal;
